module.exports = __webpack_public_path__ + "static/img/applications-system.d6c9f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applications-system.png
// module id = KuhQ
// module chunks = 1